import React, { useEffect, useRef, useState } from 'react';

/**
 * Componente che mostra e gestisce la durata della chiamata in primo piano.
 * Props:
 * - visible: boolean, se mostrare il timer
 * - onStart: funzione chiamata all'avvio del timer (opzionale)
 * - onStop: funzione chiamata alla fine del timer (opzionale)
 */

const CallDurationOverlay = ({ visible = true, onStart, onStop, style }) => {
  const [callDuration, setCallDuration] = useState(0);
  const timerRef = useRef(null);
  const callStartTimeRef = useRef(null);

  // Formatta i secondi in mm:ss
  const formatCallDuration = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (visible) {
      callStartTimeRef.current = Date.now();
      setCallDuration(0);
      if (onStart) onStart();
      timerRef.current = setInterval(() => {
        setCallDuration(Math.floor((Date.now() - callStartTimeRef.current) / 1000));
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      if (onStop) onStop();
      callStartTimeRef.current = null;
      setCallDuration(0);
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [visible, onStart, onStop]);

  if (!visible) return null;
  return (
    <div
      style={{
        position: 'absolute',
        top: 10,
        width: '100%',
        zIndex: 9999999999,
        display: window.innerWidth < 770 ? 'none' : 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        ...style
      }}
    >
      <div
        style={{
          background: 'rgba(0,0,0,0.7)',
          color: '#fff',
          padding: '4px 12px',
          borderRadius: '16px 16px 16px 16px',
          fontSize: 14,
          fontWeight: 600,
          letterSpacing: 1,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          pointerEvents: 'auto'
        }}
      >
        ⏱ Durata chiamata: {formatCallDuration(callDuration)}
      </div>
    </div>
  );
};

export default CallDurationOverlay;
